import React, { useMemo } from 'react';
import { AutocompleteArrayInput, useInput, useGetList } from 'react-admin';
import {
  makeStyles,
  Grid,
  LinearProgress,
  Typography
} from '@material-ui/core';
import { useFormState } from 'react-final-form';

const useStyles = makeStyles({
  containerCustom: {
    '& > div > label': {
      fontSize: '14px',
      marginTop: 0,
      '& > span:before': {
        content: 'none'
      }
    },
    '& > div > div': {
      padding: '5px'
    }
  },
  suggestionsCustom: {
    top: '5px !important'
  },
  disabledInput: {
    pointerEvents: 'none',
    opacity: '0.5'
  },
  gridContainerCustom: {
    marginTop: 8
  }
});

const SelectTagInput = props => {
  const {
    classes,
    id,
    source,
    resource,
    tagsList,
    tagIds,
    tagLoading,
    hasEditTagPermission
  } = props;

  const getAdditionalOptions = useMemo(() => {
    if (!hasEditTagPermission) {
      return {
        InputProps: {
          className: classes.disabledInput
        }
      };
    }
  }, [hasEditTagPermission, classes]);

  /**
   * A function to parse the value from the input to the record value
   */
  const customParse = value => {
    if (typeof value === 'object' && !Array.isArray(value)) {
      return value;
    }
    const formattedValue = {};
    Object.entries(tagsList).forEach(([_key, val]) => {
      if (value.includes(val.id)) {
        formattedValue[val.id] = val.name;
      }
    });
    return formattedValue;
  };

  const { input, isRequired, meta } = useInput({
    id,
    resource,
    source,
    parse: customParse
  });
  input.value = tagIds;

  if (tagLoading) return <LinearProgress />;

  return (
    <AutocompleteArrayInput
      id={id}
      options={getAdditionalOptions}
      disabled={!hasEditTagPermission}
      label="Assigned Tags"
      source={source}
      choices={Object.values(tagsList).sort((a, b) =>
        a.name.localeCompare(b.name)
      )}
      input={input}
      isRequired={isRequired}
      meta={meta}
      variant="standard"
      classes={{
        container: classes.containerCustom,
        suggestionsContainer: classes.suggestionsCustom
      }}
    />
  );
};

function getPropertyByPath(obj, path) {
  const keys = path.split('.');
  let currentObj = obj;

  for (const key of keys) {
    if (currentObj.hasOwnProperty(key)) {
      currentObj = currentObj[key];
    } else {
      return undefined;
    }
  }
  return currentObj;
}

const TagInput = props => {
  const { id, label, resource, source, hasEditTagPermission } = props;
  const classes = useStyles();
  const formState = useFormState();

  const {
    data: tagsList = [],
    loading: tagLoading,
    total: totalTags
  } = useGetList(resource, null, null);

  const tagIds = Object.entries(getPropertyByPath(formState.values, source))
    .sort((a, b) => a[1].localeCompare(b[1]))
    .map(tag => parseInt(tag[0]));
  if (totalTags > 0) {
    return (
      <Grid
        container
        spacing={2}
        className={
          source === 'fundInvestor.fundInvestorTags'
            ? classes.gridContainerCustom
            : null
        }
        data-testid={'gridContainer'}
      >
        {label && (
          <Grid item xs={12}>
            <Typography variant="h5">{label}</Typography>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sm={12}
          md={source === 'fundInvestor.fundInvestorTags' ? 12 : 6}
          lg={source === 'fundInvestor.fundInvestorTags' ? 12 : 3}
        >
          <SelectTagInput
            classes={classes}
            id={id}
            source={source}
            resource={resource}
            tagsList={tagsList}
            tagIds={tagIds}
            tagLoading={tagLoading}
            hasEditTagPermission={hasEditTagPermission}
          />
        </Grid>
      </Grid>
    );
  }

  return null;
};

export default TagInput;
